"use client";

import RouteErrorBoundary from "@/components/RouteErrorBoundary";

export default function AuthError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary {...props} source="(auth).error.boundary" />;
}
